// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UnsettledTransaction_pageWrap__C3KML {
  padding: 4px 4px 32px;
}

.UnsettledTransaction_desktopTable__\\+zyU3 {
  display: block;
}

.UnsettledTransaction_mobileList__y4rYo {
  display: none;
}

@media (max-width: 767px) {
  .UnsettledTransaction_desktopTable__\\+zyU3 {
    display: none;
  }
  .UnsettledTransaction_mobileList__y4rYo {
    display: block;
  }
}

/* =========================================================
   Toolbar
   ========================================================= */
.UnsettledTransaction_toolbarRow__UChLm {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 16px 24px;
  border-bottom: 1px solid #EEF0F6;
}

.UnsettledTransaction_searchInput__02B7l {
  padding: 9px 14px;
  border-radius: 10px;
  border: 1px solid #E5E7EB;
  font-size: 13.5px;
  background: #ffffff;
  min-width: 200px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.UnsettledTransaction_searchInput__02B7l:focus {
  outline: none;
  border-color: #4c2fb3;
  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);
}

.UnsettledTransaction_sellerSelect__D8V\\+M {
  padding: 9px 14px;
  border-radius: 10px;
  border: 1px solid #E5E7EB;
  font-size: 13.5px;
  background: #ffffff;
  min-width: 170px;
  flex-shrink: 0;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.UnsettledTransaction_sellerSelect__D8V\\+M:focus {
  outline: none;
  border-color: #4c2fb3;
  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);
}

.UnsettledTransaction_spacer__gbL5h {
  flex: 1 1;
}

.UnsettledTransaction_editToggle__iItdy {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #F5F3FE;
  border: 1px solid #E7DEFB;
  border-radius: 10px;
  padding: 4px;
}

.UnsettledTransaction_pillToggleBtn__tcuCV {
  border: none;
  background: transparent;
  color: #4c2fb3;
  font-size: 12.5px;
  font-weight: 700;
  padding: 6px 12px;
  border-radius: 8px;
  cursor: pointer;
  white-space: nowrap;
}
.UnsettledTransaction_pillToggleBtn__tcuCV:hover {
  background: #ffffff;
}

.UnsettledTransaction_editBtn__HqWyU {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #F5F3FE;
  color: #4c2fb3;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  padding: 9px 16px;
  cursor: pointer;
  transition: background 0.15s ease;
  white-space: nowrap;
}
.UnsettledTransaction_editBtn__HqWyU:hover {
  background: #E7DEFB;
}

.UnsettledTransaction_filterBtn__FDtpO {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);
  color: #ffffff;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  padding: 9px 16px;
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(76, 47, 179, 0.24);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  white-space: nowrap;
}
.UnsettledTransaction_filterBtn__FDtpO:hover {
  transform: translateY(-1px);
  box-shadow: 0 12px 24px rgba(76, 47, 179, 0.3);
}

.UnsettledTransaction_menuWrap__2G4Pj {
  position: relative;
}

.UnsettledTransaction_menuTrigger__rfjcV {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 1px solid #E5E7EB;
  background: #ffffff;
  color: #4c2fb3;
  cursor: pointer;
}
.UnsettledTransaction_menuTrigger__rfjcV:hover {
  background: #F5F3FE;
}

.UnsettledTransaction_menuDropdown__EvlUc {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 20;
  display: flex;
  flex-direction: column;
  gap: 6px;
  background: #ffffff;
  border: 1px solid #E7E9F1;
  border-radius: 12px;
  box-shadow: 0 20px 44px rgba(27, 37, 89, 0.16);
  padding: 10px;
  min-width: 180px;
}

.UnsettledTransaction_menuItem__qs3mE {
  display: block;
  width: 100%;
  text-align: left;
  background: transparent;
  color: #374151;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  padding: 9px 12px;
  cursor: pointer;
  transition: background 0.15s ease;
}
.UnsettledTransaction_menuItem__qs3mE:hover {
  background: #F5F3FE;
  color: #4c2fb3;
}

/* =========================================================
   Status pills
   ========================================================= */
.UnsettledTransaction_pillBase__KPqK9 {
  display: inline-flex;
  align-items: center;
  padding: 3px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}
.UnsettledTransaction_pillGreen__uIXJr { background: #E9F9EF; color: #16A34A; }
.UnsettledTransaction_pillGrey__lBs9q { background: #F3F4F6; color: #6B7280; }

/* =========================================================
   Mobile card list
   ========================================================= */
.UnsettledTransaction_mobileCard__9U3T\\+ {
  border: 1px solid #EEF0F6;
  border-radius: 14px;
  background: #ffffff;
  padding: 16px;
  margin-bottom: 12px;
}

.UnsettledTransaction_mobileRow__mi2PD {
  display: flex;
  gap: 12px;
  padding: 4px 0;
  font-size: 13px;
}

.UnsettledTransaction_mobileLabel__7Ib3z {
  min-width: 100px;
  flex-shrink: 0;
  color: #6B7280;
  font-weight: 600;
}

.UnsettledTransaction_mobileValue__TfizE {
  color: #1F2430;
}

.UnsettledTransaction_mobileViewBtn__zZ6bk {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);
  color: #ffffff;
  border: none;
  border-radius: 10px;
  font-size: 12.5px;
  font-weight: 700;
  padding: 8px 16px;
  cursor: pointer;
}

/* =========================================================
   Detail modal
   ========================================================= */
.UnsettledTransaction_modalBox__ZAHLS {
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
}

.UnsettledTransaction_modalHeader__HEsLP {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 22px;
  background: linear-gradient(120deg, #2b1657 0%, #4c2fb3 55%, #7c5cfc 100%);
  flex-shrink: 0;
}

.UnsettledTransaction_modalTitle__8svSA {
  font-family: 'Sora', 'Inter', sans-serif;
  font-size: 14.5px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
}

.UnsettledTransaction_modalClose__Cw\\+2W {
  color: #ffffff;
  cursor: pointer;
  display: flex;
  flex-shrink: 0;
}

.UnsettledTransaction_modalBody__ZxZqt {
  padding: 20px 22px;
  overflow-y: auto;
}

.UnsettledTransaction_detailRow__Vf8ZI {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 11px 0;
  border-bottom: 1px solid #F1F2F6;
}
.UnsettledTransaction_detailRow__Vf8ZI:last-child {
  border-bottom: none;
}

.UnsettledTransaction_detailLabel__B1VPX {
  font-size: 13px;
  color: #6B7280;
  font-weight: 600;
}

.UnsettledTransaction_detailValue__Xq\\+kE {
  font-size: 13.5px;
  font-weight: 700;
  color: #1F2430;
  text-align: right;
}

.UnsettledTransaction_detailInput__\\+g88m {
  width: 130px;
  text-align: right;
  padding: 7px 10px;
  border-radius: 8px;
  border: 1px solid #E5E7EB;
  font-size: 13px;
}
.UnsettledTransaction_detailInput__\\+g88m:focus {
  outline: none;
  border-color: #4c2fb3;
  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);
}

.UnsettledTransaction_modalFooter__tvA49 {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding: 16px 22px;
  border-top: 1px solid #F1F2F6;
  flex-shrink: 0;
}

.UnsettledTransaction_footerInput__FneUO {
  padding: 9px 12px;
  border-radius: 10px;
  border: 1px solid #E5E7EB;
  font-size: 13px;
}
.UnsettledTransaction_footerInput__FneUO:focus {
  outline: none;
  border-color: #4c2fb3;
  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);
}

.UnsettledTransaction_ghostBtn__2XfBx {
  background: #F3F4F6;
  color: #374151;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  padding: 9px 18px;
  cursor: pointer;
}
.UnsettledTransaction_ghostBtn__2XfBx:hover {
  background: #E5E7EB;
}

.UnsettledTransaction_primaryBtn__hiyiU {
  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);
  color: #ffffff;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  padding: 9px 18px;
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(76, 47, 179, 0.24);
}
.UnsettledTransaction_primaryBtn__hiyiU:hover {
  transform: translateY(-1px);
}
.UnsettledTransaction_primaryBtn__hiyiU:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.UnsettledTransaction_successBtn__dcoN1 {
  background: linear-gradient(135deg, #16A34A 0%, #22C55E 100%);
  color: #ffffff;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  padding: 9px 18px;
  cursor: pointer;
}

/* =========================================================
   Simple form modal (filters / upload)
   ========================================================= */
.UnsettledTransaction_simpleModalBox__pz09Z {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 92%;
  max-width: 460px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 20px 50px rgba(43, 22, 87, 0.24);
  overflow: hidden;
}

.UnsettledTransaction_field__Q8AQG {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 14px;
}

.UnsettledTransaction_label__BY36R {
  font-size: 12px;
  font-weight: 700;
  color: #6B7280;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

/* =========================================================
   Bulk-select action bar
   ========================================================= */
.UnsettledTransaction_bulkBar__GEg72 {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 18px;
  background: linear-gradient(120deg, #2b1657 0%, #4c2fb3 55%, #7c5cfc 100%);
  border-radius: 14px;
  box-shadow: 0 16px 36px rgba(43, 22, 87, 0.3);
}

.UnsettledTransaction_bulkInput__eXyTo {
  padding: 9px 12px;
  border-radius: 8px;
  border: none;
  font-size: 13px;
  min-width: 0;
}
.UnsettledTransaction_bulkInput__eXyTo:focus {
  outline: none;
}

.UnsettledTransaction_bulkSettleBtn__Xn6F7 {
  background: #ffffff;
  color: #4c2fb3;
  border: none;
  border-radius: 8px;
  font-size: 12.5px;
  font-weight: 700;
  padding: 9px 16px;
  cursor: pointer;
  white-space: nowrap;
}
.UnsettledTransaction_bulkSettleBtn__Xn6F7:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.UnsettledTransaction_bulkClose__JkH0f {
  color: #ffffff;
  cursor: pointer;
  display: flex;
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/unsettledTransaction/UnsettledTransaction.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;;AAEA;;8DAE8D;AAC9D;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0DAA0D;AAC5D;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,0DAA0D;AAC5D;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,iCAAiC;EACjC,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,6DAA6D;EAC7D,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,8CAA8C;EAC9C,uDAAuD;EACvD,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;8DAE8D;AAC9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA,yCAAa,mBAAmB,EAAE,cAAc,EAAE;AAClD,wCAAY,mBAAmB,EAAE,cAAc,EAAE;;AAEjD;;8DAE8D;AAC9D;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,6DAA6D;EAC7D,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;8DAE8D;AAC9D;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,0EAA0E;EAC1E,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,8CAA8C;AAChD;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;8DAE8D;AAC9D;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;8DAE8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,0EAA0E;EAC1E,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;AACA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,cAAc;AAChB","sourcesContent":[".pageWrap {\n  padding: 4px 4px 32px;\n}\n\n.desktopTable {\n  display: block;\n}\n\n.mobileList {\n  display: none;\n}\n\n@media (max-width: 767px) {\n  .desktopTable {\n    display: none;\n  }\n  .mobileList {\n    display: block;\n  }\n}\n\n/* =========================================================\n   Toolbar\n   ========================================================= */\n.toolbarRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 24px;\n  border-bottom: 1px solid #EEF0F6;\n}\n\n.searchInput {\n  padding: 9px 14px;\n  border-radius: 10px;\n  border: 1px solid #E5E7EB;\n  font-size: 13.5px;\n  background: #ffffff;\n  min-width: 200px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.searchInput:focus {\n  outline: none;\n  border-color: #4c2fb3;\n  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);\n}\n\n.sellerSelect {\n  padding: 9px 14px;\n  border-radius: 10px;\n  border: 1px solid #E5E7EB;\n  font-size: 13.5px;\n  background: #ffffff;\n  min-width: 170px;\n  flex-shrink: 0;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.sellerSelect:focus {\n  outline: none;\n  border-color: #4c2fb3;\n  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);\n}\n\n.spacer {\n  flex: 1;\n}\n\n.editToggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: #F5F3FE;\n  border: 1px solid #E7DEFB;\n  border-radius: 10px;\n  padding: 4px;\n}\n\n.pillToggleBtn {\n  border: none;\n  background: transparent;\n  color: #4c2fb3;\n  font-size: 12.5px;\n  font-weight: 700;\n  padding: 6px 12px;\n  border-radius: 8px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.pillToggleBtn:hover {\n  background: #ffffff;\n}\n\n.editBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: #F5F3FE;\n  color: #4c2fb3;\n  border: none;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 700;\n  padding: 9px 16px;\n  cursor: pointer;\n  transition: background 0.15s ease;\n  white-space: nowrap;\n}\n.editBtn:hover {\n  background: #E7DEFB;\n}\n\n.filterBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);\n  color: #ffffff;\n  border: none;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 700;\n  padding: 9px 16px;\n  cursor: pointer;\n  box-shadow: 0 8px 18px rgba(76, 47, 179, 0.24);\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n  white-space: nowrap;\n}\n.filterBtn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 12px 24px rgba(76, 47, 179, 0.3);\n}\n\n.menuWrap {\n  position: relative;\n}\n\n.menuTrigger {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  border: 1px solid #E5E7EB;\n  background: #ffffff;\n  color: #4c2fb3;\n  cursor: pointer;\n}\n.menuTrigger:hover {\n  background: #F5F3FE;\n}\n\n.menuDropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  z-index: 20;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  background: #ffffff;\n  border: 1px solid #E7E9F1;\n  border-radius: 12px;\n  box-shadow: 0 20px 44px rgba(27, 37, 89, 0.16);\n  padding: 10px;\n  min-width: 180px;\n}\n\n.menuItem {\n  display: block;\n  width: 100%;\n  text-align: left;\n  background: transparent;\n  color: #374151;\n  border: none;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 9px 12px;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n.menuItem:hover {\n  background: #F5F3FE;\n  color: #4c2fb3;\n}\n\n/* =========================================================\n   Status pills\n   ========================================================= */\n.pillBase {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n.pillGreen { background: #E9F9EF; color: #16A34A; }\n.pillGrey { background: #F3F4F6; color: #6B7280; }\n\n/* =========================================================\n   Mobile card list\n   ========================================================= */\n.mobileCard {\n  border: 1px solid #EEF0F6;\n  border-radius: 14px;\n  background: #ffffff;\n  padding: 16px;\n  margin-bottom: 12px;\n}\n\n.mobileRow {\n  display: flex;\n  gap: 12px;\n  padding: 4px 0;\n  font-size: 13px;\n}\n\n.mobileLabel {\n  min-width: 100px;\n  flex-shrink: 0;\n  color: #6B7280;\n  font-weight: 600;\n}\n\n.mobileValue {\n  color: #1F2430;\n}\n\n.mobileViewBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 10px;\n  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);\n  color: #ffffff;\n  border: none;\n  border-radius: 10px;\n  font-size: 12.5px;\n  font-weight: 700;\n  padding: 8px 16px;\n  cursor: pointer;\n}\n\n/* =========================================================\n   Detail modal\n   ========================================================= */\n.modalBox {\n  background: #ffffff;\n  border-radius: 16px;\n  overflow: hidden;\n  max-height: 85vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.modalHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 18px 22px;\n  background: linear-gradient(120deg, #2b1657 0%, #4c2fb3 55%, #7c5cfc 100%);\n  flex-shrink: 0;\n}\n\n.modalTitle {\n  font-family: 'Sora', 'Inter', sans-serif;\n  font-size: 14.5px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0;\n}\n\n.modalClose {\n  color: #ffffff;\n  cursor: pointer;\n  display: flex;\n  flex-shrink: 0;\n}\n\n.modalBody {\n  padding: 20px 22px;\n  overflow-y: auto;\n}\n\n.detailRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 11px 0;\n  border-bottom: 1px solid #F1F2F6;\n}\n.detailRow:last-child {\n  border-bottom: none;\n}\n\n.detailLabel {\n  font-size: 13px;\n  color: #6B7280;\n  font-weight: 600;\n}\n\n.detailValue {\n  font-size: 13.5px;\n  font-weight: 700;\n  color: #1F2430;\n  text-align: right;\n}\n\n.detailInput {\n  width: 130px;\n  text-align: right;\n  padding: 7px 10px;\n  border-radius: 8px;\n  border: 1px solid #E5E7EB;\n  font-size: 13px;\n}\n.detailInput:focus {\n  outline: none;\n  border-color: #4c2fb3;\n  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);\n}\n\n.modalFooter {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10px;\n  padding: 16px 22px;\n  border-top: 1px solid #F1F2F6;\n  flex-shrink: 0;\n}\n\n.footerInput {\n  padding: 9px 12px;\n  border-radius: 10px;\n  border: 1px solid #E5E7EB;\n  font-size: 13px;\n}\n.footerInput:focus {\n  outline: none;\n  border-color: #4c2fb3;\n  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);\n}\n\n.ghostBtn {\n  background: #F3F4F6;\n  color: #374151;\n  border: none;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 700;\n  padding: 9px 18px;\n  cursor: pointer;\n}\n.ghostBtn:hover {\n  background: #E5E7EB;\n}\n\n.primaryBtn {\n  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);\n  color: #ffffff;\n  border: none;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 700;\n  padding: 9px 18px;\n  cursor: pointer;\n  box-shadow: 0 8px 18px rgba(76, 47, 179, 0.24);\n}\n.primaryBtn:hover {\n  transform: translateY(-1px);\n}\n.primaryBtn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.successBtn {\n  background: linear-gradient(135deg, #16A34A 0%, #22C55E 100%);\n  color: #ffffff;\n  border: none;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 700;\n  padding: 9px 18px;\n  cursor: pointer;\n}\n\n/* =========================================================\n   Simple form modal (filters / upload)\n   ========================================================= */\n.simpleModalBox {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 92%;\n  max-width: 460px;\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 20px 50px rgba(43, 22, 87, 0.24);\n  overflow: hidden;\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 14px;\n}\n\n.label {\n  font-size: 12px;\n  font-weight: 700;\n  color: #6B7280;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n/* =========================================================\n   Bulk-select action bar\n   ========================================================= */\n.bulkBar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 18px;\n  background: linear-gradient(120deg, #2b1657 0%, #4c2fb3 55%, #7c5cfc 100%);\n  border-radius: 14px;\n  box-shadow: 0 16px 36px rgba(43, 22, 87, 0.3);\n}\n\n.bulkInput {\n  padding: 9px 12px;\n  border-radius: 8px;\n  border: none;\n  font-size: 13px;\n  min-width: 0;\n}\n.bulkInput:focus {\n  outline: none;\n}\n\n.bulkSettleBtn {\n  background: #ffffff;\n  color: #4c2fb3;\n  border: none;\n  border-radius: 8px;\n  font-size: 12.5px;\n  font-weight: 700;\n  padding: 9px 16px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.bulkSettleBtn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.bulkClose {\n  color: #ffffff;\n  cursor: pointer;\n  display: flex;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrap": `UnsettledTransaction_pageWrap__C3KML`,
	"desktopTable": `UnsettledTransaction_desktopTable__+zyU3`,
	"mobileList": `UnsettledTransaction_mobileList__y4rYo`,
	"toolbarRow": `UnsettledTransaction_toolbarRow__UChLm`,
	"searchInput": `UnsettledTransaction_searchInput__02B7l`,
	"sellerSelect": `UnsettledTransaction_sellerSelect__D8V+M`,
	"spacer": `UnsettledTransaction_spacer__gbL5h`,
	"editToggle": `UnsettledTransaction_editToggle__iItdy`,
	"pillToggleBtn": `UnsettledTransaction_pillToggleBtn__tcuCV`,
	"editBtn": `UnsettledTransaction_editBtn__HqWyU`,
	"filterBtn": `UnsettledTransaction_filterBtn__FDtpO`,
	"menuWrap": `UnsettledTransaction_menuWrap__2G4Pj`,
	"menuTrigger": `UnsettledTransaction_menuTrigger__rfjcV`,
	"menuDropdown": `UnsettledTransaction_menuDropdown__EvlUc`,
	"menuItem": `UnsettledTransaction_menuItem__qs3mE`,
	"pillBase": `UnsettledTransaction_pillBase__KPqK9`,
	"pillGreen": `UnsettledTransaction_pillGreen__uIXJr`,
	"pillGrey": `UnsettledTransaction_pillGrey__lBs9q`,
	"mobileCard": `UnsettledTransaction_mobileCard__9U3T+`,
	"mobileRow": `UnsettledTransaction_mobileRow__mi2PD`,
	"mobileLabel": `UnsettledTransaction_mobileLabel__7Ib3z`,
	"mobileValue": `UnsettledTransaction_mobileValue__TfizE`,
	"mobileViewBtn": `UnsettledTransaction_mobileViewBtn__zZ6bk`,
	"modalBox": `UnsettledTransaction_modalBox__ZAHLS`,
	"modalHeader": `UnsettledTransaction_modalHeader__HEsLP`,
	"modalTitle": `UnsettledTransaction_modalTitle__8svSA`,
	"modalClose": `UnsettledTransaction_modalClose__Cw+2W`,
	"modalBody": `UnsettledTransaction_modalBody__ZxZqt`,
	"detailRow": `UnsettledTransaction_detailRow__Vf8ZI`,
	"detailLabel": `UnsettledTransaction_detailLabel__B1VPX`,
	"detailValue": `UnsettledTransaction_detailValue__Xq+kE`,
	"detailInput": `UnsettledTransaction_detailInput__+g88m`,
	"modalFooter": `UnsettledTransaction_modalFooter__tvA49`,
	"footerInput": `UnsettledTransaction_footerInput__FneUO`,
	"ghostBtn": `UnsettledTransaction_ghostBtn__2XfBx`,
	"primaryBtn": `UnsettledTransaction_primaryBtn__hiyiU`,
	"successBtn": `UnsettledTransaction_successBtn__dcoN1`,
	"simpleModalBox": `UnsettledTransaction_simpleModalBox__pz09Z`,
	"field": `UnsettledTransaction_field__Q8AQG`,
	"label": `UnsettledTransaction_label__BY36R`,
	"bulkBar": `UnsettledTransaction_bulkBar__GEg72`,
	"bulkInput": `UnsettledTransaction_bulkInput__eXyTo`,
	"bulkSettleBtn": `UnsettledTransaction_bulkSettleBtn__Xn6F7`,
	"bulkClose": `UnsettledTransaction_bulkClose__JkH0f`
};
export default ___CSS_LOADER_EXPORT___;
